import axios from 'axios';
import { sessionPayload } from '../utils/session';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

 // Replace with your API base URL

// export function setAuthToken(token) {
//     if(token){
//         api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//     }
//     else{
//         delete api.defaults.headers.common['Authorization'];
//     }
// }

const getAuthPayload = sessionPayload;

export async function get(endpoint,params={},config={}) {
    try {
        const response = await api.get(endpoint,{params,...config});
        return response.data;
    } catch (error) {
        console.error("Error in GET request:", { status: error.response?.status || null });
        throw error;
    }
}
export const post = async (url, data = {}, config = {}) => {
  try {
    const payload = {  ...data };
    const res = await api.post(url, payload, config);
    return res.data;
  } catch (error) {
    console.error("API POST error:", { status: error.response?.status || null });
    throw error.response?.data || error;
  }
};
export async function put(endpoint,data={},config={}) {
    try {
        const response = await api.put(endpoint,data,config);
        return response.data;
    } catch (error) {
        console.error("Error in PUT request:", { status: error.response?.status || null });
        throw error;
    }
}
export async function del(endpoint,config={}) {
    try {
        const response = await api.delete(endpoint,config);
        return response.data;
    } catch (error) {
        console.error("Error in DELETE request:", { status: error.response?.status || null });
        throw normalizeError(error);
    }
}
export const postFromData = async (url, formData = new FormData()) => {
  try {
    // add token/users_id/role_id directly into formData
    const { token, users_id, role_id } = getAuthPayload();
    for (const [key, value] of Object.entries({ token, users_id, role_id })) {
      if (!formData.has(key)) formData.set(key, value);
    }

    const res = await api.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.error("API FORM error:", { status: error.response?.status || null });
    throw error.response?.data || error;
  }
};

function normalizeError(error) {
    if(error.response){
        return {
            status: error.response.status,
            data: error.response.data,
            message: error.response.data.message || 'An error occurred'
        };
    }
    else if(error.request){
        return {
            status: null,
            data: null,
            message: 'No response from server. Please check your network.'
        };
    }
    else{
        return {
            status: null,
            data: null,
            message: 'An unexpected error occurred.'
        };  
    }
}

api.interceptors.response.use(
    response => response,
    error => {
  if(error.response?.status===401)
    {
    }
    return Promise.reject(error);
});

export {normalizeError};
export default api;
